{
  "title": "Magnify Gravity",
  "source": "Explorer's Guide to Wildemount",
  "levelAndSchool": "1st-level transmutation (dunamancy:graviturgy)",
  "level": 1,
  "castingTime": "1 action",
  "range": "60 feet",
  "components": "V, S",
  "duration": "1 round",
  "description": [
    "The gravity in a 10-foot-radius sphere centered on a point you can see within range increases for a moment. Each creature in the sphere on the turn when you cast the spell must make a Constitution saving throw. On a failed save, a creature takes 2d8 force damage, and its speed is halved until the end of its next turn. On a successful save, a creature takes half as much damage and suffers no reduction to its speed.",
    "Until the start of your next turn, any object that isn't being worn or carried in the sphere requires a successful Strength check against your spell save DC to pick up or move.",
    "At Higher Levels. When you cast this spell using a spell slot of 2nd level or higher, the damage increases by 1d8 for each slot level above 1st."
  ],
  "spellLists": ["wizard"]
}
